import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { HomeIcon, ChevronLeftIcon } from "../components/Icons";

export default function NotFound() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100svh",
      background: theme.bg.base,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: theme.font.body,
      color: theme.text.primary,
      padding: 24,
    }}>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50%       { transform: translateY(-10px); }
        }
      `}</style>

      <div style={{ textAlign: "center", maxWidth: 440 }}>
        {/* Big 404 */}
        <div style={{
          fontFamily: theme.font.display,
          fontSize: "clamp(80px, 18vw, 140px)",
          fontWeight: 800,
          lineHeight: 1,
          letterSpacing: "-0.04em",
          background: `linear-gradient(135deg, ${theme.accent.gold}, ${theme.accent.goldLight})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          animation: "float 4s ease-in-out infinite",
          marginBottom: 8,
          userSelect: "none",
        }}>
          404
        </div>

        {/* Title */}
        <div style={{
          fontFamily: theme.font.display,
          fontWeight: 800,
          fontSize: 22,
          marginBottom: 10,
          letterSpacing: "-0.02em",
        }}>
          Page not found
        </div>

        {/* Description */}
        <div style={{
          color: theme.text.muted,
          fontSize: 14,
          fontFamily: theme.font.mono,
          lineHeight: 1.7,
          marginBottom: 32,
        }}>
          The page you're looking for doesn't exist or has been moved.
        </div>

        {/* Actions */}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: "flex", alignItems: "center", gap: 8,
              background: "none",
              border: `1px solid ${theme.border.default}`,
              borderRadius: theme.radius.md,
              padding: "11px 20px",
              color: theme.text.secondary,
              fontFamily: theme.font.body,
              fontSize: 14,
              cursor: "pointer",
              transition: "border-color 0.15s, color 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = theme.border.accent; e.currentTarget.style.color = theme.text.primary; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = theme.border.default; e.currentTarget.style.color = theme.text.secondary; }}
          >
            <ChevronLeftIcon size={15} /> Go back
          </button>

          <button
            onClick={() => navigate("/dashboard")}
            style={{
              display: "flex", alignItems: "center", gap: 8,
              background: "linear-gradient(135deg, #eab308, #f59e0b)",
              border: "none",
              borderRadius: theme.radius.md,
              padding: "11px 20px",
              color: "#000",
              fontFamily: theme.font.display,
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              transition: "opacity 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = "0.9")}
            onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
          >
            <HomeIcon size={15} color="#000" /> Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
